import type { ReactNode } from "react";
import { EventsBasePathContext } from "./_eventsBasePathContext";

export function EventsBasePathProvider({ basePath, children }: { basePath: string; children: ReactNode }) {
  return <EventsBasePathContext.Provider value={basePath}>{children}</EventsBasePathContext.Provider>;
}
